import { serviceDirectoryApiClient } from '@/services/service-directory';

export interface CategoryForm {
  entryType: string;
  name: string;
  industry: string;
  description: string;
  icon: string;
  order: number;
}

class Category {
  fetchCategories = async (entryType: string, industry?: string) => {
    const response = await serviceDirectoryApiClient.get(
      `categories?entryType=${entryType || ''}&industry=${industry || ''}`
    );
    return response.data;
  };

  fetchCategory = async (id: string) => {
    const response = await serviceDirectoryApiClient.get(`categories/${id}`);
    return response.data;
  };

  createCategory = async (category: CategoryForm) => {
    const formData = this.formDataCategory(category);
    const response = await serviceDirectoryApiClient.post('/categories', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  };

  updateCategory = async (id: string, category: CategoryForm) => {
    const formData = this.formDataCategory(category);
    const response = await serviceDirectoryApiClient.put(`/categories/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  };

  deleteCategory = async (id: string) => {
    const response = await serviceDirectoryApiClient.delete(`/categories/${id}`);
    return response.data;
  };

  private formDataCategory = (category: CategoryForm) => {
    const formData = new FormData();
    formData.append('name', category.name);
    if (typeof category.icon === 'string') {
      formData.append('iconUrl', category.icon);
    } else {
      formData.append('icon', category.icon);
    }
    formData.append('industry', category.industry ?? '');
    formData.append('entryType', category.entryType ?? '');
    formData.append('order', category.order.toString() ?? '');
    formData.append('description', category.description ?? '');
    return formData;
  };
}

export const CategoryInstance = new Category();
